import { buildValue } from "../controlledReduxModule/selectors";

export const uncontrolledValueSelector = (
  valueSelector: (state: any) => string | Date | null,
) => (state: any) => buildValue(valueSelector(state));
